module.exports = __webpack_public_path__ + "static/raleway-regular-43c849ea0258ce0d23a480e840881f16.woff2";